var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08501 0.381049C10.7576 -0.127016 15.5874 -0.127016 20.2599 0.381049C22.0142 0.571802 23.5544 1.49475 24.5285 2.83514L12.4158 14.6191L8.67831 10.9831C8.23506 10.5518 7.5164 10.5518 7.07315 10.9831C6.6299 11.4143 6.6299 12.1134 7.07315 12.5446L11.6133 16.9615C12.0566 17.3928 12.7751 17.3928 13.2184 16.9615L25.5001 5.01315C25.534 5.17447 25.5612 5.33828 25.5812 5.5043C26.14 10.1523 26.14 14.8478 25.5812 19.4957C25.256 22.2003 23.0239 24.3184 20.2599 24.619C15.5874 25.127 10.7576 25.127 6.08501 24.619C3.32102 24.3184 1.08896 22.2003 0.763812 19.4957C0.205031 14.8478 0.205031 10.1523 0.763812 5.5043C1.08896 2.79972 3.32102 0.681577 6.08501 0.381049Z",
    fill: "#A2E08C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check-2.3ac676941ec6631e4f4e3f2b9826a291.svg";
export { ForwardRef as ReactComponent };